import { useCallback } from 'react';
import { i18n } from '@lingui/core';
import { Trans } from '@lingui/react';
import { Icon, Text } from '@mindbaz/ui-v2';

import linkedin from 'assets/linkedin.svg';
import twitter from 'assets/twitter.svg';
import {
  CustomLink,
  CustomText,
  Flex,
  LinkFooter,
  Media,
  PanelFooter,
} from 'pages/Features/styledComponents';

const MEDIA = {
  TWITTER: { label: 'twitter', url: 'https://twitter.com/' },
  LINKEDIN: { label: 'linkedin', url: 'https://linkedin.com/' },
};

const Footer = () => {
  const handleRedirection = useCallback((media: string) => {
    if (media === MEDIA.TWITTER.label) window.open(MEDIA.TWITTER.url, '_blank');
    if (media === MEDIA.LINKEDIN.label)
      window.open(MEDIA.LINKEDIN.url, '_blank');
  }, []);

  return (
    <div>
      <PanelFooter>
        <div>
          <Text variant="h2" weight="semibold">
            <Trans
              id="feature.footer.featureInProgress"
              message="More features are on the way."
            />
          </Text>
          <Text variant="subtitle">
            <Trans
              id="feature.footer.follow"
              message="Stay tuned so you don't miss out!"
            />
          </Text>
        </div>
        <Flex>
          <Media
            onClick={() => {
              handleRedirection('linkedin');
            }}
          >
            <img src={linkedin} alt="linkedin" />
          </Media>

          <Media
            onClick={() => {
              handleRedirection('twitter');
            }}
          >
            <img src={twitter} alt="twitter" />
          </Media>
        </Flex>
      </PanelFooter>
      <LinkFooter>
        <Text align="center">
          <Trans
            id="feature.footer.optimizeEmail"
            message="Want to optimize your email marketing?"
          />
        </Text>
        <CustomText className="align-center mt-8">
          <CustomLink
            href={i18n._('features.footer.followEmailTrainingLink')}
            target="_blank"
          >
            <Trans
              id="feature.footer.followEmailTraining"
              message="Take an email training course with Mindbaz"
            />
          </CustomLink>
          <Icon color="light" size={4}>
            circle
          </Icon>
          <CustomLink
            href={i18n._('features.footer.learnMoreLink')}
            target="_blank"
          >
            <Trans
              id="feature.footer.learnMore"
              message="Find out more about Mindbaz's email audits"
            />
          </CustomLink>
        </CustomText>
      </LinkFooter>
    </div>
  );
};

export default Footer;
